import axios from 'axios';
import { useEffect,useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import { useNavigate } from 'react-router-dom';




function AffichageSelectionJoueur(props) {
    const [isLoading,setIsLoading] = useState(false)
    const [error,setError] = useState();
    const { idMatch } = useParams();
    const [joueur,setJoueur] = useState()
    const [pasDispo,setPasDispo] = useState()
    const Navigate = useNavigate();
    const [status,setStatus] = useState()
    const [commentaire,setCommentaire] = useState()
    const [confirmation,setConfirmation] = useState(false)
    const apiUrl = process.env.REACT_APP_API_URL;



    useEffect(() => {
        setIsLoading(true);
        const fetchData = async () => {
          try {
            const response = await axios.get(
              `${apiUrl}/selection/affichage/joueur/${props.userData.user.donnée.results[0].id_equipe}/${idMatch}/${props.userData.user.donnée.results[0].id}`,
              {
                withCredentials: true 
              }
            );
            
            setError(null);
            setIsLoading(false);
            setJoueur(response.data);
    
          } catch (error) {
            if (error.response) {
              if (error.response.status === 404) {
                setPasDispo(error.response.data);
            } else {
                setError(error.response.data.message);
            }
          } else {
              setError(true);
          }
          setIsLoading(false);
      }
  };
    
        fetchData(); 
      }, [props, idMatch, apiUrl]);


      const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
          await axios.patch(`${apiUrl}/selection/status/joueur`, {
            idEquipe : props.userData.user.donnée.results[0].id_equipe,
            idJoueur : props.userData.user.donnée.results[0].id,
            idMatch : idMatch,
            commentaire : commentaire,
            status : status
          }, {
            withCredentials: true
          });
    
          setError(null);
          setIsLoading(false);
          window.location.reload(); 
  
        } catch (error) {
          if (error.response) {
            setIsLoading(false)
            setError(error.response.data.message);
          } else {
            setIsLoading(false)
            setError(true);
          }
        }
      };


  return (
    <>
      {error && (
        <div id="alert-message" className="alert5" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
       )}
      {pasDispo && (
        <Modal show={pasDispo} onHide={() => Navigate('/joueurs/tableau-de-bord/selection')}>
          <Modal.Header closeButton>
            <Modal.Title>Sélection pas encore disponible</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Malheureusement, la sélection pour le match {pasDispo.match[0].equipe_dom} - {pasDispo.match[0].equipe_ext} n'a pas encore été crées par votre coach.</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => Navigate('/joueurs/tableau-de-bord/selection')} >
              Quitter
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    {joueur &&
      <>
        <Card className="bg-dark text-white" style={{borderRadius: "var(--bs-card-border-radius)"}}>
            <Card.Img src="/img/matchArbitre.jpg" alt="Card image" />
            <Card.ImgOverlay>
            <div className="text-center mb-3">
              <Card.Title><strong>Sélection : {joueur.match[0].equipe_dom} - {joueur.match[0].equipe_dom}</strong></Card.Title>
            </div>
          </Card.ImgOverlay>
        </Card><br/>
        <Card>
          <Card.Header>Sélection du coach</Card.Header>
          <Card.Body>
          <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
            <Card.Text>Votre statut pour le match {joueur.match[0].equipe_dom} - {joueur.match[0].equipe_ext} </Card.Text>
            <Form.Select aria-label="Default select example"  defaultValue={joueur.selection[0].status} disabled>
                      <option value="Pas sélectionné">Pas sélectionné</option>
                      <option value="Sélectionné" >Sélectionné</option>
                      <option value="Blessé">Blessé</option>
                </Form.Select>
                <Form.Label>Commentaire personnel</Form.Label>
                <Form.Control as="textarea" rows={3} disabled value={joueur.selection[0].commentaire} />
                <Form.Label>Commentaire pour toute l'équipe</Form.Label>
                <Form.Control as="textarea" rows={3} disabled value={joueur.match_commentaire[0].commentaire} />
          </Form.Group>
            {joueur.selection[0].status === 'Blessé' ? (
              <>
                <Card.Text><strong>Si vous êtes finalement apte à disputer le match cliquer sur 'Je peut participer à ce match'.</strong></Card.Text>
                <Button variant="primary" onClick={() => {setStatus('Pas sélectionné');setConfirmation(true);setCommentaire('')}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Je peut pas participer à ce match</Button>
              </>
            ):(
              <>
                <Card.Text><strong>Si vous n'êtes pas apte à disputer le match cliquer sur 'Je ne peut pas participer à ce match' et ajouter eventuellement un commentaire.</strong></Card.Text>
                <Form.Label>Commentaire sur votre non-participation :</Form.Label>
                <Form.Control as="textarea" rows={3} value={commentaire} onChange={(e) => setCommentaire(e.target.value)} /><br/>
                <Button variant="primary" onClick={() => {setStatus('Blessé');setConfirmation(true)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Je ne peut pas participer à ce match</Button>
              </>
            )}
          </Card.Body>
        </Card>
    </>
    }
    <br/>
    {confirmation && (
        <Modal show={confirmation} onHide={() => {setConfirmation(false);setCommentaire();setStatus()}}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Voulez-vous vraiment changer votre statut pour le match {joueur.match[0].equipe_dom} - {joueur.match[0].equipe_ext} ?</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {setConfirmation(false);setCommentaire();setStatus()}} >
              Quitter
            </Button>
            <Button variant="primary" onClick={(e) => {handleSubmit(e);setConfirmation(false)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}} >
              Confirmer
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    
    {isLoading && (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
    )}
  </>
  );
}

export default AffichageSelectionJoueur;